import React from 'react'
import {DocumentTextIcon, RectangleGroupIcon} from "@heroicons/react/24/solid";

const ShowDesignMetaDetail = ({designDetail}) => {

    return (
        <>
            {/*{designDetail?.meta && designDetail?.meta?.descriptionList?.length > 0 &&
                <div className="text-green-500 ml-1">
                    <DocumentTextIcon className="h-6 w-6"/>
                </div>
            }*/}

            {designDetail?.content && designDetail?.content?.contentList?.length > 0 &&
                <div className="text-green-500 ml-1 flex justify-start">
                    <DocumentTextIcon className="h-6 w-6"/>
                    <span className={'font-bold'}>{designDetail?.content?.contentList?.length}</span>
                </div>
            }

            {designDetail?.isTemplateReady &&
                <div className="text-sky-500 ml-1 flex justify-start">
                    <RectangleGroupIcon className="h-6 w-6"/>
                </div>
            }
        </>
    )
}

export default ShowDesignMetaDetail
